var _path, _path2, _path3, _path4, _g, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoServicesSubscribe(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 97.3467C76.1488 97.3467 97.3467 76.1488 97.3467 50C97.3467 23.8511 76.1488 2.65332 50 2.65332C23.8511 2.65332 2.65332 23.8511 2.65332 50C2.65332 76.1488 23.8511 97.3467 50 97.3467Z",
    fill: "#e5fff2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7733 29.9466C54.58 29.7599 54.34 29.6399 54.08 29.5866C53.9933 29.5666 53.9 29.5599 53.8133 29.5599H37.86C35.5733 29.6333 34.34 30.7933 34.2666 33.1533V67.1133C34.24 69.0133 35.2066 70.4333 37.5866 70.4333H62.2866C64.2866 70.3599 65.6467 69.0399 65.72 66.9999V40.9733C65.72 40.8133 65.6933 40.6599 65.64 40.5133C65.5666 40.3066 65.4466 40.1199 65.2866 39.9666L54.7733 29.9466Z",
    fill: "#008056",
    stroke: "#008056",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.58 40.3466H57.0133C55.4666 40.3466 54.3733 39.2266 54.3733 37.7066V29.6799",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.58 40.3466H57.0133C55.4666 40.3466 54.3733 39.2266 54.3733 37.7066V29.6799",
    stroke: "#008056",
    strokeWidth: 2.5246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.54 39.2733H49.06",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.54 45.12H53.0067",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.54 50.9667H56.2934",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5201 80.9532C39.5054 80.9532 43.5467 76.9119 43.5467 71.9266C43.5467 66.9413 39.5054 62.8999 34.5201 62.8999C29.5348 62.8999 25.4934 66.9413 25.4934 71.9266C25.4934 76.9119 29.5348 80.9532 34.5201 80.9532Z",
    fill: "#008056"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.28 73.7932L35.4066 71.9199L37.28 70.0465C37.3466 69.9799 37.3466 69.8799 37.28 69.8132L36.6266 69.1599C36.56 69.0932 36.46 69.0932 36.3933 69.1599L34.52 71.0332L32.6466 69.1599C32.58 69.0932 32.48 69.0932 32.4133 69.1599L31.76 69.8132C31.6933 69.8799 31.6933 69.9799 31.76 70.0465L33.6333 71.9199L31.76 73.7932C31.6933 73.8599 31.6933 73.9599 31.76 74.0265L32.4133 74.6799C32.48 74.7465 32.58 74.7465 32.6466 74.6799L34.52 72.8065L36.3933 74.6799C36.46 74.7465 36.56 74.7465 36.6266 74.6799L37.28 74.0265C37.34 73.9665 37.34 73.8599 37.28 73.7932Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoServicesSubscribe);
export default __webpack_public_path__ + "static/media/noServicesSubscribe.f214efa1cd86d77a2ff570af83c4b974.svg";
export { ForwardRef as ReactComponent };